import Link from 'next/link';
import dayjs from 'dayjs';
// Helpers
import { withCDN } from 'helpers/cdn';
import { formatCurrencyStringWithoutName } from 'helpers/formatCurrencyString';
// Constants
import { dateTimeAtFormat } from 'constants/global';
// Types
import { EventMediaItem } from '../types';
// Styles
import styles from './EventMediaCard.module.scss';

const FALLBACK_IMAGE = '/images/logos/mobile-logo-black.svg';

type EventMediaCardProps = {
  item: EventMediaItem;
};

const EventMediaCard = ({ item }: EventMediaCardProps): JSX.Element => {
  const scheduledAt = dayjs(item.scheduledAt);
  const priceLabel = item.isFree
    ? 'FREE'
    : formatCurrencyStringWithoutName(item.price);

  return (
    <Link href={item.href}>
      <a className={styles.root}>
        <span className={styles.imageFrame}>
          <span className={styles.image}>
            <img
              src={item.imageUrl || withCDN(FALLBACK_IMAGE)}
              alt={item.title}
              className={styles.artwork}
              loading="lazy"
              decoding="async"
            />
            <span className={styles.dateBadge}>
              {scheduledAt.format('DD MMM').toUpperCase()}
            </span>
            <span className={styles.priceBadge}>{priceLabel}</span>
          </span>
        </span>

        <span className={styles.details}>
          <span className={styles.title}>{item.title}</span>
          <span className={styles.publisher}>{item.publisherName}</span>
          <time className={styles.date} dateTime={item.scheduledAt}>
            {scheduledAt.format(dateTimeAtFormat)}
          </time>
        </span>
      </a>
    </Link>
  );
};

export default EventMediaCard;
